import React from 'react'
import withConfiguration from '../../hoc/withConfiguration'
import _ from 'lodash'
import SadRobbie from './robbie.svg'

type Props = {
  currentFloor: any
  currentBuilding: any
  floorError?: boolean
  buildingError?: boolean
  configuration: any
  title: string
}
const ErrorPageClassification = ({
  floorError,
  buildingError,
  currentFloor,
  currentBuilding,
  configuration,
  title,
}: Props): any => {
  const floorErrorMessage = () => {
    const { stargateUrl } = configuration

    const floorName = _.get(currentFloor, 'name', '')

    let message = (
      <p>
        Unfortunately, our tool is not currently receiving physical space data
        for this floor of <b>{currentBuilding.name}</b>
      </p>
    )
    if (floorName) {
      message = (
        <p>
          Unfortunately, our tool is not currently receiving physical space data
          for floor <b>{floorName}</b> of
          <b>{` ${currentBuilding.name}`}</b>
        </p>
      )
    }

    return (
      <div>
        <p>
          <b>{`Hello, and thank you for using the ${title}!`}</b>
        </p>
        {message}
        <p>
          Please check this specific floor is valid within the{' '}
          <b>Sales Floor Plan</b> {`for ${currentBuilding.name} in `}
          <a href={stargateUrl}>Stargate</a>
        </p>
        <p>
          If this specific floor within the Sales Floor Plan is missing, we are
          unable to display any information. Please contact your local building
          Design Technologist (VDC team) to ensure this floor is accurate and
          up-to-date. Our tool will populate the floor within 48 hours after the
          model is uploaded, harvested and synched in Stargate.
        </p>
        <p>
          For any questions, please contact us via slack{' '}
          <a href="https://wework.slack.com/messages/CA7GNESU9/">
            (#tech-occupancy-map)
          </a>{' '}
          or submitting a ticket to{' '}
          <a
            href="https://wecompany.force.com/employeesupport/s/apps-and-digital-products"
            target="blank"
          >
            https://wecompany.force.com/employeesupport/s/apps-and-digital-products
          </a>
        </p>
        <p>Thanks,</p>
        <p>The Location Based Experiences team</p>
      </div>
    )
  }

  const buildingErrorMessage = () => {
    const { stargateUrl } = configuration

    return (
      <div>
        <p>
          <b>{`Hello, and thank you for using the ${title}!`}</b>
        </p>
        <p>
          Unfortunately, our tool is not currently receiving physical space data
          for <b>{currentBuilding.name}</b>
        </p>
        <p>
          Please check the <b>Sales Floor Plan</b>{' '}
          {`for ${currentBuilding.name} in `}
          <a href={stargateUrl}>Stargate</a>
        </p>
        <p>
          If the floor plans are missing, it is likely that{' '}
          <b>Layout Signoff</b> has not yet occurred, and we are unable to
          display any information. Our tool will populate a floor plan within 48
          hours after the model is uploaded, harvested and synched in Stargate
          by the building Design Technologist (VDC team)
        </p>
        <p>
          For any questions, please contact us via slack{' '}
          <a href="https://wework.slack.com/messages/CA7GNESU9/">
            (#tech-occupancy-map)
          </a>{' '}
          or submitting a ticket to{' '}
          <a
            href="https://wecompany.force.com/employeesupport/s/apps-and-digital-products"
            target="blank"
          >
            https://wecompany.force.com/employeesupport/s/apps-and-digital-products
          </a>
        </p>
        <p>Thanks,</p>
        <p>The Location Based Experiences team</p>
      </div>
    )
  }

  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f9f9f9',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'row',
          maxWidth: 1000,
          margin: 'auto',
          zIndex: 1000,
        }}
      >
        {/* style={{ width: 200, height: 'auto' }}  */}
        <SadRobbie />
        <div
          style={{
            flex: 1,
            color: '#404040',
            maxWidth: 1000,
            padding: 40,
            lineHeight: 1.4,
          }}
        >
          {floorError ? floorErrorMessage() : null}
          {buildingError ? buildingErrorMessage() : null}
        </div>
      </div>
    </div>
  )
}

export default withConfiguration()(ErrorPageClassification)
